// --- Navbar.jsx ---
import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo_id.png";
import "../components/NavBar.css";
function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="navbar">
      <div className="Clogo">
        <Link to="/">
          <img src={logo} alt="Logo" style={{ height: "90px", }} />
        </Link>
      </div>

      {/* Hamburger */}
      <div
        className={`hamburger ${menuOpen ? "active" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <div className="bar top-bar"></div>
        <div className="bar middle-bar"></div>
        <div className="bar bottom-bar"></div>
      </div>

      {/* Navigation Menu */}
      <div className={`nav-content ${menuOpen ? "active" : ""}`}>
        <nav className="nav-links">
          <ul className="menu">
            <li><Link to="/" className="nav-link">Home</Link></li>
            <li><Link to="/about" className="nav-link">About Us</Link></li>
            <li><Link to="/services" className="nav-link">Services</Link></li>
            <li><Link to="/successStories" className="nav-link">Success Stories</Link></li>
            <li><Link to="/ourTeam" className="nav-link">Our Team</Link></li>
            <li><Link to="/contact" className="nav-link">Contact Us</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
}
export default Navbar;
